import React, {useState} from 'react';
import S from 'StyledAccountShareBetIcon.js';
import { withRouter } from 'react-router-dom';
import { translation } from 'utilsHelper.js';

const AccountShareBetIcon = ({type, transaction: { transactionId, multiCouponCombinationDetails }, showCopyInfo}) => {
    const generateShareLink = () => {
        const baseURL = `${translation('deepLinkShare')}/kupon/${transactionId}`;
        const { combinationId } = multiCouponCombinationDetails?.[0] ?? {};
        return combinationId ? `${baseURL}/${combinationId}` : baseURL;
    }

    const [shareLink, setShareLink] = useState(generateShareLink());
    
    const shareTypeHandler = () => {

        switch(type) {
            case "facebook":
                shareFacebookHandler();
                break;
            case "twitter": 
                shareTwitterHandler();
                break;
            case "link": 
                shareLinkHandler();
                break;
            default:
                console.log("ACCOUNTSHAREBETICON: miss matched type");
        }
    };

    const shareFacebookHandler = () => {
        let fbLink = `${translation('facebookShareLink')}${encodeURIComponent(shareLink)}`;
        window.open(fbLink, 'fbShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
    }

    const shareTwitterHandler = () => {

        let twLink = `${translation('XShareLink')}${encodeURIComponent(shareLink)}`;
        window.open(twLink, 'twShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
        return false;
    }

    const shareLinkHandler = () => {
        navigator.clipboard.writeText(shareLink);
        showCopyInfo();
    }

    return (
        <S.AccountShareBetIconWrapper className={type} onClick={shareTypeHandler}>
        </S.AccountShareBetIconWrapper>
    )


};

export default withRouter(AccountShareBetIcon);
